import moment from 'moment-timezone';
moment.tz.setDefault(document.documentElement.dataset['tz'] || moment.tz.guess() || 'Asia/Hong_Kong');

export default moment;
